<template>
    <div class="product-sold">
        <i class="las la-cart-arrow-down" aria-hidden="true"></i>
        <span v-html="sold"></span>
    </div>
</template>

<script>
    export default {
        props: ['sold'],

        computed: {
          
        },
    };
</script>
